// return flattened object
export default function flattenObject(object: Record<string, any>, joinStyle: string): Record<string, any> {
  const toReturn = {};

  for (const i in object) {
    if (!object.hasOwnProperty(i)) continue;

    if (typeof object[i] === "object") {
      const flatObject = flattenObject(object[i], joinStyle);
      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        if (joinStyle == "[]") {
          toReturn[`${i}[${x}]`] = flatObject[x];
        } else {
          toReturn[`${i}.${x}`] = flatObject[x];
        }
      }
    } else {
      toReturn[i] = object[i];
    }
  }
  return toReturn;
}
